import { getRandomNumber } from 'src/shared/utils/get-random-number';

import type { TGeologicalLoadData } from '../../geological-load-tab/types';

import { GeologicalLoad } from './geological-load.entity';

export class GeoLoadSection {
  readonly entityId: number;
  readonly rigOperationEntityId: number;
  readonly stageEntityId: number;
  readonly sectionEntityId: number;
  readonly geologicalLoad: GeologicalLoad;

  constructor(
    rigOperationEntityId: number,
    stageEntityId: number,
    sectionEntityId: number,
    initialGeoLoad?: TGeologicalLoadData | null,
  ) {
    this.entityId = getRandomNumber(10);

    this.rigOperationEntityId = rigOperationEntityId;
    this.stageEntityId = stageEntityId;
    this.sectionEntityId = sectionEntityId;
    this.geologicalLoad = new GeologicalLoad(initialGeoLoad);
  }
}
